import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import {
  fetchCombosApi,
  fetchCombosFilterApi,
  fetchCombosByIdApi,
  createCombosApi,
  fetchComboProductsApi,
  fetchComboEzdsApi,
  deleteComboProductApi,
  updateComboApi,
} from "../../../api/endpoint";

function* getCombosSaga(action) {
  try {
    const _api = yield call(fetchCombosApi, action.payload);
    yield put(actions.setCombos(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    yield put(commonActions.setLoading(false));
  }
}

function* getComboProductsSaga(action) {
  try {
    const _api = yield call(fetchComboProductsApi, action.payload);
    yield put(actions.setComboProducts(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* updateComboSaga(action) {
  try {
    const _api = yield call(updateComboApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setUpdatedCombo(action.payload));
      yield put(commonActions.setRedirect(true));

      yield put(actions.getCombos(action.params));

      yield put(
        commonActions.setAlert({
          message: "Combo Successfully Updated",
          alertType: "success",
          alertStatus: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(commonActions.setRedirect(false));
    yield put(
      commonActions.setAlert({
        alertStatus: true,
        message: "Something went wrong",
        showToast: "error",
      })
    );
  }
}

function* getComboEzdsSaga(action) {
  try {
    const _api = yield call(fetchComboEzdsApi, action.payload);
    yield put(actions.setComboEzds(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* filterCombosSaga(action) {
  try {
    const _api = yield call(fetchCombosFilterApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setComboFilteredResults(_api.data.results));
      yield put(commonActions.setClearFilter(true));
    }
  } catch (error) {
    console.log(error);
  }
}

function* getCombosByIdSaga(action) {
  try {
    const _api = yield call(fetchCombosByIdApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setComboById(..._api.data.results));
      yield put(commonActions.setLoading(false));
    }
  } catch (error) {
    console.log(error);
  }
}

function* createCombosSaga(action) {
  try {
    const _api = yield call(createCombosApi, action.payload);
    yield put(commonActions.setLoading(false));
    if (_api?.data?.success) {
      yield put(commonActions.setRedirect(true));
      yield put(actions.addCombosSuccesful(true));
      yield put(
        commonActions.setAlert({
          message: "Combo Successfully Added",
          alertType: "success",
          alertStatus: true,
        })
      );
    }
  } catch (error) {
    yield put(commonActions.setError(true));
    yield put(commonActions.setRedirect(false));

    yield put(
      commonActions.setAlert({
        message: error.response.data.message,
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
  }
}

function* deleteComboProductsSaga(action) {
  try {
    const _api = yield call(deleteComboProductApi, action.payload);
    if (_api?.data?.success) {
      yield put(actions.setRemoveProduct(action.payload));
      yield put(commonActions.setRedirect(true));
      yield put(
        commonActions.setAlert({
          message: "combo Product Successfully deleted",
          alertType: "success",
          alertStatus: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(commonActions.setRedirect(true));
    yield put(
      commonActions.setAlert({
        alertStatus: true,
        message: "Something went wrong",
        alertType: "error",
      })
    );
  }
}

export function* watchCombosSaga() {
  yield all([
    takeEvery(actionTypes.GET_COMBOS, getCombosSaga),
    takeEvery(actionTypes.GET_COMBO_FILTERED_RESULTS, filterCombosSaga),
    takeEvery(actionTypes.GET_COMBOS_BY_ID, getCombosByIdSaga),
    takeEvery(actionTypes.ADD_COMBOS, createCombosSaga),
    takeEvery(actionTypes.GET_COMBO_PRODUCTS, getComboProductsSaga),
    takeEvery(actionTypes.GET_COMBO_EZDS, getComboEzdsSaga),
    takeEvery(actionTypes.DELETE_COMBO_PRODUCT, deleteComboProductsSaga),
    takeEvery(actionTypes.UPDATE_COMBO, updateComboSaga),
  ]);
}
